import axios from 'axios'

import config from '@/config'
import sessionToken from '@/functions/sessionToken'
import store from '@/store'

const api = axios.create({
  baseURL: config.appUrl + '/api/'
})

let timeout = null

api.interceptors.request.use(config => {
  // Add session token to all requests if it's present
  // in the user's browser storage
  const token = sessionToken.get()

  if (token) {
    config.headers.Authorization = 'Token ' + token
  }

  return config
})

api.interceptors.response.use(response => {
  return response
}, error => {
  // Assume a network error if the error response is empty
  if (!error.response && !timeout) {
    store.commit('notifications/add', {
      text: 'Es konnte keine Verbindung zum Server hergestellt werden. Versuchen Sie es bitte später erneut.',
      type: 'error',
      timeout: 0
    })

    // Throttle network error notification
    timeout = setTimeout(() => { timeout = null }, 300)
  }

  return Promise.reject(error)
})

export default api
